import { useCallback, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react'; 
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

export default function Grid(props) {
    const gridRef = useRef();

    const defaultColDef = {
        editable: true
    }

    const autoSizeStrategy = () => {
        return {
            type: "fitCellContents"
        };
    }

    const onGridReady = useCallback((params) => {
        const allColumnIds = [];
        gridRef.current.api.getColumns().forEach((column) => {
            allColumnIds.push(column.getId());
        });
        gridRef.current.api.autoSizeColumns(allColumnIds, false);
    }, []);

    return (
        <div
         className="ag-theme-quartz" 
         style={{ height: 500 }}
        >
          <AgGridReact
              ref={gridRef}
              rowData={props.rowData}
              columnDefs={props.columnDefs}
              autoSizeStrategy={autoSizeStrategy}
              onGridReady={onGridReady}
              cellSelection={true}
              defaultColDef={defaultColDef}
          />
        </div>
    )
}